// src/utils/auth.js (amélioré)

// Utilitaires pour la gestion de l'authentification

export const setAuthToken = (token) => {
    if (token) {
        // Normaliser: stocker uniquement le JWT (sans préfixe "Bearer ")
        const normalized = String(token).replace(/^Bearer\s+/i, '').trim();
        localStorage.setItem('token', normalized);
    } else {
        localStorage.removeItem('token');
    }
};

export const getAuthToken = () => {
    return localStorage.getItem('token');
};

export const setUser = (user) => {
    localStorage.setItem('user', JSON.stringify(user));
};

export const getUser = () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
};

export const clearAuth = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
};

export const isAuthenticated = () => {
    const token = getAuthToken();
    return !!token && !isTokenExpired(token);
};

// Helper: décodage Base64URL -> JSON
const decodeJwtPayload = (token) => {
    const parts = token.split('.');
    if (parts.length < 2) throw new Error('JWT invalide');
    const base64Url = parts[1];
    // convertir base64url en base64
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    // ajouter le padding si nécessaire
    const padded = base64.padEnd(base64.length + (4 - (base64.length % 4)) % 4, '=');
    const json = atob(padded);
    return JSON.parse(json);
};

// Nouvelle fonction pour vérifier si le token est expiré
export const isTokenExpired = (token) => {
    if (!token) return true;

    try {
        // Décoder le payload du JWT (partie du milieu)
        const payload = decodeJwtPayload(token);
        const currentTime = Date.now() / 1000;

        // Vérifier si le token est expiré
        return typeof payload.exp === 'number' ? payload.exp < currentTime : true;
    } catch (error) {
        console.error('Erreur lors de la vérification du token:', error);
        return true; // Si erreur, considérer comme expiré
    }
};

// Fonction pour obtenir les informations du token
export const getTokenInfo = (token) => {
    if (!token) return null;

    try {
        const payload = decodeJwtPayload(token);
        return {
            userId: payload.id ?? payload.sub,
            exp: payload.exp,
            iat: payload.iat,
            isExpired: typeof payload.exp === 'number' ? payload.exp < Date.now() / 1000 : true
        };
    } catch (error) {
        console.error('Erreur lors du décodage du token:', error);
        return null;
    }
};
